import { apiClient } from "../client";
const ENDPOINTS = {
    ADHOC_INVOICE: "/xero/adhoc/invoice",
    INVOICE: "/xero/invoice",
    INVOICES_BY_CONTACT: "/xero/invoices",
    LINK: "/xero/link",
};
export const xeroService = {
    createAdhocInvoice: (dto) => apiClient.post(ENDPOINTS.ADHOC_INVOICE, dto),
    createInvoice: (dto) => apiClient.post(ENDPOINTS.INVOICE, dto),
    getInvoicesByContact: (contactId) => apiClient.get(`${ENDPOINTS.INVOICES_BY_CONTACT}/${contactId}`),
    getInvoiceLink: (invoiceId) => apiClient.get(`${ENDPOINTS.LINK}/${invoiceId}`),
};
